<template>
  <div class="bb-accordion-button"
       :class="{'bb-accordion-button_hide': listData.length <= 1}"
  >
    <div class="bb-accordion-button-control"
         @click="setOpen(!openContent)"
    >
      <div class="bb-accordion-button-control__icon"
           v-if="!openContent"
      >
        <Plus/>
      </div>
      <div class="bb-accordion-button-control__icon"
           v-else
      >
        <Minus/>
      </div>
    </div>
  </div>
</template>

<script>
import Plus from '@/components/Main/Icons/Plus'
import Minus from '@/components/Main/Icons/Minus'
import {get} from 'lodash'
export default {
  name: 'AccordionButton',
  props: ['row', 'list'],
  components: {
    Plus,
    Minus
  },
  computed: {
    listData () {
      return this.list || []
    }
  },
  data () {
    return {
      openContent: false
    }
  },
  methods: {
    setOpen (val) {
      this.openContent = val
      this.$set(this.row, '$accordionContent', val)
    }
  },
  watch: {
    row: {
      handler () {
        const val = get(this.row, '$accordionContent', false)
        this.setOpen(val)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

.bb-accordion-button {
  @include global-font;

  &-control {
    position: relative;
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
    box-sizing: border-box;
    border: 1px solid rgba($color-silver, 0.3);
    color: $color-accent;
    transition: 0.3s;
    cursor: pointer;

    &:hover {
      color: $color-accent-hover;
      border-color: rgba($color-silver, 0.6);
    }

    &__icon {
      position: absolute;
      top: auto;
      left: auto;
      width: 10px;
      height: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0;
      transition: 0.2s;

      &:before {
        margin: 0;
      }
    }
  }

  &_hide {
    opacity: 0;
    pointer-events: none;
    cursor: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Main/AccordionButton/AccordionButton.vue